enum ProjectStatus {
  Understanding = "UNDERSTANDING",
  Estimate = "ESTIMATE",
  ProposalSending = "PROPOSAL_SENDING",
  WaitingApproval = "WAITING_APPROVAL",
  Approved = "APPROVED",
  Disapproved = "DISAPPROVED",
  Assigning = "ASSIGNING",
  Canceled = "CANCELED",
  Suspended = "SUSPENDED",
  WaitingDevelopment = "WAITING_DEVELOPMENT",
  Development = "DEVELOPMENT",
  Concluded = "CONCLUDED",
}

export default ProjectStatus;
